import { render } from "./J2369AnnualReport.vue?vue&type=template&id=4b8d5071&ts=true&lang=pug"
import script from "./J2369AnnualReport.vue?vue&type=script&lang=ts"
export * from "./J2369AnnualReport.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__